import { useQuery } from "@tanstack/react-query";

import type { IncidenceTypeEntityT } from "../domain/entities/incidenceType.entity";
import type { IncidenceTypeUiT } from "../domain/ui/incidenceType.model";

import type { IncidenceTypesRepositoryT } from "../domain/ports/incidenceTypes.repository";

import { getIncidenceTypes } from "../application/useCases/getIncidenceTypes";

const toUiModel = (data: IncidenceTypeEntityT[]): IncidenceTypeUiT[] =>
  data
    .map((item) => ({
      id: item.id,
      active: item.active ?? null,
      leaderUse: item.leaderUse ?? null,
      name: item.name ?? null,
      code: item.code ?? null,
      typeOfIncident: item.typeOfIncident ?? null,
      descriptionTypeOfIncident: item.descriptionTypeOfIncident ?? null,
      unitValue: item.unitValue ?? null,
      percentage: item.percentage ?? null,
      typeItConsiders: item.typeItConsiders ?? null,
      descriptionItConsiders: item.descriptionItConsiders ?? null,
      salaryRight: item.salaryRight ?? null,
      decreasesSeventhDay: item.decreasesSeventhDay ?? null,
      accummulatedTypes: item.accummulatedTypes ?? null,
    }))
    .filter((incidenceType) => incidenceType.active);

export const createUseIncidenceTypes = ({
  incidenceTypesRepository,
}: {
  incidenceTypesRepository: IncidenceTypesRepositoryT;
}) => {
  return function useIncidenceTypes() {
    return useQuery({
      queryKey: ["shared/incidence-types"],
      queryFn: () => getIncidenceTypes({ incidenceTypesRepository }),
      select: toUiModel,
    });
  };
};
